import React from 'react'
import classes from './Loader.module.sass'

export const Loader = () => {
  return <div className={classes.Loader} />
}
